import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import Dialog from 'react-dialog';
const URL_PATTERN = /^(https?:\/\/)[\w.-]+\.[a-z]{2,}(\/\S*)?$/i;
const PHONE_PATTERN = /^\+\d{12}$/;

const getInitialSuggestions = (formData, carousels, activeIndex) => {
    if (formData.templateType === "richcardstandalone") {
        return formData.standaloneCard?.temp_suggestion || [];
    }
    if (formData.templateType === "richcardcarousel") {
        return carousels?.[activeIndex]?.temp_suggestion || [];
    }
    return formData.suggestionsButton || [];
};

const SuggestionsButtonUi = ({ formData, setFormData, activeIndex, carousels, setCarousels, setError }) => {
    const [suggestions, setSuggestions] = useState(getInitialSuggestions(formData, carousels, activeIndex));
    const [isDialogOpen, setisDialogOpen] = useState({ status: false, index: '' });
    const [enableUrl, setEnableUrl] = useState([]);
    const [mainUrl, setMainUrl] = useState([]);
    const [btnCount, setBtnCount] = useState([]);
    const [fieldErrors, setFieldErrors] = useState([]);

    const [suggestionBtnIndex, setSuggestionBtnIndex] = useState(1);


    // Add new carousel and tab
    const addSuggestions = () => {
        if (suggestions.length < 3) {
            const newSuggestions = {
                type_of_action: "",
                suggestion_text: "",
                suggestion_postback: "",
                url: "",
                phone_number: '',
            };
            setSuggestions([...suggestions, newSuggestions]);
        }
    };

    const handleAddSuggestionVariable = (index) => {
        const updatedSuggestions = [...suggestions];

        // 1️⃣ Collect used btn numbers
        const usedBtnNumbers = new Set();

        const extractBtns = (text = "") => {
            const matches = text.match(/\[btn(\d+)\]/g);
            if (!matches) return;

            matches.forEach((m) => {
                const num = Number(m.replace(/\D/g, ""));
                usedBtnNumbers.add(num);
            });
        };

        // current suggestions
        suggestions.forEach((s) => {
            extractBtns(s?.suggestion_text);
        });

        // standalone card
        if (
            formData &&
            formData.standaloneCard &&
            Array.isArray(formData.standaloneCard.temp_suggestion)
        ) {
            formData.standaloneCard.temp_suggestion.forEach((s) => {
                extractBtns(s?.suggestion_text);
            });
        }

        // carousel cards
        if (formData && Array.isArray(formData.carousels)) {
            formData.carousels.forEach((card) => {
                if (Array.isArray(card.temp_suggestion)) {
                    card.temp_suggestion.forEach((s) => {
                        extractBtns(s?.suggestion_text);
                    });
                }
            });
        }

        // 2️⃣ Find next available btn index
        let nextBtnIndex = 1;
        while (usedBtnNumbers.has(nextBtnIndex)) {
            nextBtnIndex++;
        }

        const variable = `[btn${nextBtnIndex}]`;

        // 3️⃣ Append variable
        updatedSuggestions[index] = {
            ...updatedSuggestions[index],
            suggestion_text:
                (updatedSuggestions[index]?.suggestion_text || "") + variable,
        };

        setSuggestions(updatedSuggestions);
        setSuggestionBtnIndex(nextBtnIndex + 1);

        // 4️⃣ Sync with formData
        if (formData.templateType === "text") {
            setFormData((prev) => ({
                ...prev,
                suggestionsButton: updatedSuggestions,
            }));
        }

        if (formData.templateType === "richcardstandalone") {
            setFormData((prev) => ({
                ...prev,
                standaloneCard: {
                    ...prev.standaloneCard,
                    temp_suggestion: updatedSuggestions,
                },
            }));
        }

        if (formData.templateType === "richcardcarousel") {
            const updatedCarousels = [...carousels];

            updatedCarousels[activeIndex] = {
                ...updatedCarousels[activeIndex],
                temp_suggestion: updatedSuggestions,
            };

            setCarousels(updatedCarousels);

            setFormData((prev) => ({
                ...prev,
                carousels: updatedCarousels,
            }));
        }
    };




    // Handle changes to carousel form data
    const handleCarouselChange = (index, e) => {
        const { name } = e.target;
        // Trim URL and phone number values immediately
        const value = (name === "url" || name === "phone_number")
            ? e.target.value.trim()
            : e.target.value;

        const updatedSuggestions = [...suggestions];
        updatedSuggestions[index][name] = value;
        setSuggestions(updatedSuggestions);

        // Inline field validation
        if (name === "url") {
            const newErrors = [...fieldErrors];
            if (!newErrors[index]) newErrors[index] = {};
            newErrors[index].url = value && !URL_PATTERN.test(value)
                ? "Please enter a valid URL (e.g. https://example.com)"
                : "";
            setFieldErrors(newErrors);
        }

        if (name === "phone_number") {
            const newErrors = [...fieldErrors];
            if (!newErrors[index]) newErrors[index] = {};
            newErrors[index].phone = value && !PHONE_PATTERN.test(value)
                ? "Please enter a valid phone number with country code (e.g. 919876543210)"
                : "";
            setFieldErrors(newErrors);
        }

        if (formData.templateType === "text") {
            setFormData((prevData) => ({
                ...prevData,
                suggestionsButton: updatedSuggestions,
            }));
        }

        if (formData.templateType === 'richcardstandalone') {
            // this is for Inside rich 
            setFormData((prevData) => ({
                ...prevData, standaloneCard: {
                    ...prevData.standaloneCard,
                    temp_suggestion: updatedSuggestions
                }
            }));
        }

        if (formData.templateType === 'richcardcarousel') {
            // this is for Inside rich 
            const updatedCarousels = [...carousels];
            updatedCarousels[activeIndex] = {
                ...updatedCarousels[activeIndex], // Spread the existing carousel data
                temp_suggestion: suggestions
            };

            setCarousels(updatedCarousels);

            // Also update the formData with the modified carousels array
            setFormData((prevData) => ({
                ...prevData,
                carousels: updatedCarousels,
            }));
        }
    };

    const deleteSuggestions = () => {
        const afterDelete = suggestions.filter((_, i) => i !== isDialogOpen.index);
        setSuggestions(afterDelete);
        if (formData.templateType === "text") {
            setFormData(prev => ({ ...prev, suggestionsButton: afterDelete }));
        }
        if (formData.templateType === "richcardstandalone") {
            setFormData(prev => ({
                ...prev,
                standaloneCard: { ...prev.standaloneCard, temp_suggestion: afterDelete }
            }));
        }
        if (formData.templateType === "richcardcarousel") {
            const updatedCarousels = [...carousels];
            updatedCarousels[activeIndex] = {
                ...updatedCarousels[activeIndex],
                temp_suggestion: afterDelete
            };
            setCarousels(updatedCarousels);
            setFormData(prev => ({ ...prev, carousels: updatedCarousels }));
        }
        setisDialogOpen({ status: false, index: '' });
    };

    const handleClose = () => setisDialogOpen({ status: false, index: '' })

    return (
        <div className="suggested-button">

            {
                isDialogOpen.status &&
                <Dialog
                    title="Alert"
                    modal={true}
                    onClose={handleClose}
                    buttons={
                        [{
                            text: "Close",
                            className: 'btn-info btn-sm btn mr-2',
                            onClick: () => handleClose()
                        },
                        {
                            text: "ok",
                            className: 'btn btn-sm btn-danger',
                            onClick: () => deleteSuggestions()
                        }]
                    }>
                    <p>Are You Sure ? Want to Delete this Button </p>
                </Dialog>
            }



            <h5 className="suggested-title">Suggested Action/Reply Button</h5>
            <div className="text-right">
                <button type="button" onClick={addSuggestions} className="btn btn-sm btn-info">
                    + Add Suggestions
                </button>
            </div>

            {/* suggestions Button ui */}
            {suggestions.map((item, index) => (
                <div key={index}>
                    <div className="form-row mt-2">
                        <div className={`form-group  drop-down-icons ${item.type_of_action === "url_action" || item.type_of_action === "dialer_action" ? 'col-md-3' : 'col-md-5'} `}>
                            <select
                                className="form-control"
                                name="type_of_action"
                                value={item.type_of_action}
                                onChange={(e) => handleCarouselChange(index, e)}
                            >
                                <option value="">Select Type</option>
                                <option value="reply">Reply</option>
                                <option value="url_action">URL Action</option>
                                <option value="dialer_action">Dialer Action</option>
                            </select>
                        </div>
                        <div className={`form-group ${item.type_of_action === "url_action" || item.type_of_action === "dialer_action" ? 'col-md-4' : 'col-md-6'} `}>
                            <input
                                type="text"
                                className="form-control"
                                name="suggestion_text"
                                value={item.suggestion_text}
                                onChange={(e) => handleCarouselChange(index, e)}
                                placeholder="Suggestions Text"
                                maxLength={25}
                            />
                        </div>
                        {/* <div className={`form-group ${item.type_of_action === "url_action" || item.type_of_action === "dialer_action" ? 'col-md-3' : 'col-md-4'} `}>
                            <input
                                type="text"
                                className="form-control"
                                name="suggestion_postback"
                                value={item.suggestion_postback}
                                onChange={(e) => handleCarouselChange(index, e)}
                                placeholder="Suggestions Postback"
                                maxLength={120}
                            />
                        </div> */}

                        {item.type_of_action === "url_action" && (
                            <div className={`form-group ${item.type_of_action === "url_action" ? 'col-md-4' : 'col-md-6'} `}>
                                <input
                                    type="text"
                                    className={`form-control ${fieldErrors[index]?.url ? 'is-invalid' : ''}`}
                                    name="url"
                                    value={item.url}
                                    onChange={(e) => handleCarouselChange(index, e)}
                                    placeholder="Enter URL / URI to open"
                                />
                                {fieldErrors[index]?.url && (
                                    <small className="text-danger">{fieldErrors[index].url}</small>
                                )}
                            </div>
                        )}

                        {item.type_of_action === "dialer_action" && (
                            <div className={`form-group ${item.type_of_action === "dialer_action" ? 'col-md-4' : 'col-md-6'} `}>
                                <input
                                    type="text"
                                    className={`form-control ${fieldErrors[index]?.phone ? 'is-invalid' : ''}`}
                                    name="phone_number"
                                    value={item.phone_number}
                                    onChange={(e) => handleCarouselChange(index, e)}
                                    placeholder="phone number to dial (e.g. 919876543210)"
                                />
                                {fieldErrors[index]?.phone && (
                                    <small className="text-danger">{fieldErrors[index].phone}</small>
                                )}
                            </div>
                        )}

                        <div onClick={() => setisDialogOpen({ status: true, index: index })} className="form-group col-md-1">
                            <span className="btn btn-sm btn-danger"><FontAwesomeIcon icon={faTrash} /></span>
                        </div>
                    </div>
                    {item.type_of_action !== "url_action" &&
                        <div className="form-row">
                            <div className="col-6"></div>
                            <div className="col-6">
                                <button
                                    type="button"
                                    style={{ color: "white", backgroundColor: "#ff8434" }}
                                    className="btn float-right py-0 px-2"
                                    onClick={() => handleAddSuggestionVariable(index)}
                                >
                                    <span style={{ fontSize: "13px" }}>Add Variable</span>
                                </button>

                            </div>
                        </div>}

                    {item.type_of_action === "url_action" && (
                        <div className="form-row align-items-center mt-2">
                            {/* Checkbox */}
                            <div className="col-6">
                                <div className="form-check">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id={`enableUrl-${index}`}
                                        checked={enableUrl[index] || false}
                                        onChange={() => {
                                            setEnableUrl(prev => {
                                                const copy = [...prev];
                                                copy[index] = !copy[index];
                                                return copy;
                                            });
                                        }}
                                    />

                                    <label htmlFor={`enableUrl-${index}`}>
                                        Enable URL Action
                                    </label>

                                </div>
                            </div>

                            {/* Input */}
                            {enableUrl[index] && (
                                <div className="col-6">
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={mainUrl[index] || ""}
                                            onChange={(e) => {
                                                const copy = [...mainUrl];
                                                copy[index] = e.target.value;
                                                setMainUrl(copy);
                                            }}
                                        />

                                        <div className="input-group-append">
                                            <button
                                                type="button"
                                                className="btn btn-sm"
                                                style={{ color: "white", backgroundColor: "#ff8434" }}
                                                onClick={() => {
                                                    const urlCopy = [...mainUrl];
                                                    const countCopy = [...btnCount];

                                                    const count = countCopy[index] || 1;
                                                    urlCopy[index] = (urlCopy[index] || "") + `[btn${count}]`;
                                                    countCopy[index] = count + 1;

                                                    setMainUrl(urlCopy);
                                                    setBtnCount(countCopy);
                                                }}
                                            >
                                                Add Variable
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}




                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export const validateAllSuggestions = (suggestions = []) => {
    const URL_PATTERN = /^(https?:\/\/)[\w.-]+\.[a-z]{2,}(\/\S*)?$/i;
    const PHONE_PATTERN = /^\+\d{12}$/;
    const errors = [];
    suggestions.forEach((item, index) => {
        const err = {};
        if (item.type_of_action === "url_action") {
            if (!item.url || !URL_PATTERN.test(item.url.trim())) {
                err.url = "Please enter a valid URL (e.g. https://example.com)";
            }
        }
        if (item.type_of_action === "dialer_action") {
            if (!item.phone_number || !PHONE_PATTERN.test(item.phone_number.trim())) {
                err.phone = "Please enter a valid 12-digit number with country code (e.g. 919876543210)";
            }
        }
        if (Object.keys(err).length > 0) errors[index] = err;
    });
    return errors;
};

export default SuggestionsButtonUi;
